import { useState, useEffect } from "react";
import api from "../../services/api";
import { toast } from 'react-toastify';

/* ── Category Icons ─────────────────────────────────────────── */
const CategoryIcons = {
  all: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
      <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
    </svg>
  ),
  account: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  verification: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>
    </svg>
  ),
  banking: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  ),
  collection: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
    </svg>
  ),
  communication: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
    </svg>
  ),
  digital: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2"/><path d="M9 7h6M9 11h6M9 15h4" strokeLinecap="round"/>
    </svg>
  ),
};

/* ── Service Icon Map ───────────────────────────────────────── */
const ICON_MAP = {
  "payout":         <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20" strokeLinecap="round"/><circle cx="7" cy="15" r="1" fill="currentColor"/></svg>,
  "money-transfer": <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" strokeLinecap="round"/></svg>,
  "recharge":       <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><rect x="5" y="2" width="14" height="20" rx="2"/><path d="M9 7h6M9 11h6M9 15h4" strokeLinecap="round"/></svg>,
  "aeps":           <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" strokeLinecap="round"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" strokeLinecap="round"/></svg>,
  "pan-card":       <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18" strokeLinecap="round"/><circle cx="7" cy="15" r="1" fill="currentColor"/></svg>,
};

const getIcon = (slug) => ICON_MAP[slug] || (
  <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
    <circle cx="12" cy="12" r="3"/><path d="M19.07 4.93a10 10 0 010 14.14M4.93 4.93a10 10 0 000 14.14" strokeLinecap="round"/>
  </svg>
);

// const CATEGORIES = [
//   { id: "all",           label: "All Services" },
//   { id: "account",       label: "Account" },
//   { id: "verification",  label: "Verification" },
//   { id: "banking",       label: "Banking" },
//   { id: "collection",    label: "Collection" },
//   { id: "communication", label: "Communication" },
//   { id: "digital",       label: "Digital Product" },
// ];

const PAGE_SIZE = 8;

const statusStyle = {
  Pending:  { cls: "bg-amber-50 text-amber-600 border border-amber-200",       dot: "bg-amber-400" },
  Approved: { cls: "bg-emerald-50 text-emerald-600 border border-emerald-200", dot: "bg-emerald-400" },
  Rejected: { cls: "bg-red-50 text-red-600 border border-red-200",             dot: "bg-red-400" },
};

export default function ServiceAccessControl() {
  const [search, setSearch]                 = useState("");
  const [searchInput, setSearchInput]       = useState("");
  const [page, setPage]                     = useState(1);
  const [services, setServices]             = useState([]);
  const [activeRequests, setActiveRequests] = useState([]);
  const [requestPagination, setRequestPagination] = useState({ current_page: 1, last_page: 1, total: 0, has_more: false });
  const [loading, setLoading]               = useState(true);
  const [activeCategory, setActiveCategory] = useState("all");
  const [activeFilter, setActiveFilter]     = useState("All");

  /* ── API calls unchanged ──────────────────────────────────── */
  const fetchServiceRequests = async (pg = page, srch = search) => {
    const reqRes = await api.get('/service-requests', {
      params: { page: pg, limit: PAGE_SIZE, search: srch || undefined },
    });
    const reqPayload = reqRes.data?.data || reqRes.data || {};
    const reqRows = Array.isArray(reqPayload?.requests)
      ? reqPayload.requests
      : Array.isArray(reqPayload?.data)
        ? reqPayload.data
        : Array.isArray(reqPayload)
          ? reqPayload
          : [];
    const p = reqPayload?.pagination || {};
    const currentPage = Number(p?.current_page) || pg;
    const lastPage = Number(p?.last_page) || 1;
    setActiveRequests(reqRows);
    setRequestPagination({
      current_page: currentPage,
      last_page: lastPage,
      total: Number(p?.total) || reqRows.length,
      has_more: Boolean(p?.has_more ?? currentPage < lastPage),
    });
  };

  const fetchServices = async () => {
    try {
      const availRes = await api.get('/services/available');
      if (availRes.data?.data) setServices(availRes.data.data);
      await fetchServiceRequests(1, "");
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchServices(); }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      setSearch(searchInput.trim());
    }, 300);
    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    fetchServiceRequests(page, search).catch(() => {});
  }, [page, search]);

  const requestAccess = async (service_id) => {
    try {
      await api.post('/service-requests', { service_id });
      toast.success("Access requested successfully");
      fetchServices();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to request access");
    }
  };
  /* ─────────────────────────────────────────────────────────── */

  const handleSearch = (v) => { setSearchInput(v); };

  const filteredServices = services.filter(s => {
    if (activeFilter === "Pending") return s.request_status === "pending";
    if (activeFilter === "Active")  return s.has_access || s.request_status === "approved";
    if (activeFilter === "Rejected") return s.request_status === "rejected";
    return true;
  });

  const activeCount   = services.filter(s => s.has_access || s.request_status === "approved").length;
  const pendingCount  = services.filter(s => s.request_status === "pending").length;
  const rejectedCount = services.filter(s => s.request_status === "rejected").length;

  return (
    <div className="flex-1 overflow-y-auto px-8 py-6">

          {/* ── Page Header ── */}
          <div className="mb-6">
            <div className="flex items-center justify-between gap-4">
              <div>
                <h1 className="text-[28px] font-extrabold text-[#34094D] leading-tight">Service Access Control</h1>
                <p className="text-[14px] text-[#7D747F] font-medium mt-1">
                  Manage and request access to financial service modules for your merchant account.
                </p>
              </div>
                 {/* Filter tabs + search row */}
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-1 bg-white rounded-[14px] border border-[#F0EBF4] p-1 shadow-[0px_2px_8px_rgba(75,35,100,0.04)]">
                  {["All", "Pending", "Active", "Rejected"].map(f => (
                    <button
                      key={f}
                      onClick={() => setActiveFilter(f)}
                      className={`px-5 py-2 text-[12px] font-bold rounded-[10px] border-none cursor-pointer transition-all ${
                        activeFilter === f
                          ? "bg-gradient-to-r from-[#754F89] to-[#4B2364] text-white shadow-[0px_2px_8px_rgba(75,35,100,0.25)]"
                          : "bg-transparent text-[#7D747F] hover:text-[#34094D]"
                      }`}
                    >
                      {f}
                      {f === "Pending" && pendingCount > 0 && (
                        <span className={`ml-1.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                          activeFilter === "Pending" ? "bg-white/20" : "bg-amber-100 text-amber-600"
                        }`}>{pendingCount}</span>
                      )}
                      {f === "Active" && activeCount > 0 && (
                        <span className={`ml-1.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                          activeFilter === "Active" ? "bg-white/20" : "bg-emerald-100 text-emerald-600"
                        }`}>{activeCount}</span>
                      )}
                      {f === "Rejected" && rejectedCount > 0 && (
                        <span className={`ml-1.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                          activeFilter === "Rejected" ? "bg-white/20" : "bg-red-100 text-red-600"
                        }`}>{rejectedCount}</span>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-5">

            {/* ── Left Sidebar ── */}
            {/* <div className="w-56 shrink-0">
              <div className=" p-3 sticky top-0">
                <p className="text-[12px] font-bold font-regular text-[#4C444E] uppercase tracking-widest px-3 pt-2 pb-3">Categories</p>
                <div className="space-y-0.5">
                  {CATEGORIES.map(cat => (
                    <button
                      key={cat.id}
                      onClick={() => setActiveCategory(cat.id)}
                      className={`w-full flex items-center justify-between px-3 py-2.5 rounded-[12px] text-[13px] font-semibold border-none cursor-pointer transition-all ${
                        activeCategory === cat.id
                          ? "bg-gradient-to-r from-[#754F89] to-[#4B2364] text-white shadow-[0px_4px_12px_rgba(75,35,100,0.3)]"
                          : "bg-transparent text-[#4C444E] hover:bg-[#F3F4F5]"
                      }`}
                    >
                      <div className="flex items-center gap-2.5">
                        <span className={activeCategory === cat.id ? "text-white/80" : "text-[#7D747F]"}>
                          {CategoryIcons[cat.id]}
                        </span>
                        <span>{cat.label}</span>
                      </div>
                      {cat.id === "all" && services.length > 0 && (
                        <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
                          activeCategory === "all" ? "bg-white/20 text-white" : "bg-[#4B2364]/10 text-[#4B2364]"
                        }`}>{services.length}</span>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            </div> */}

            {/* ── Main Content ── */}
            <div className="flex-1 min-w-0 space-y-5">

              {/* Service Cards Grid */}
              {loading ? (
                <div className="flex items-center justify-center py-24">
                  <div className="w-9 h-9 border-4 border-[#4B2364] border-t-transparent rounded-full animate-spin" />
                </div>
              ) : filteredServices.length === 0 ? (
                <div className="py-20 text-center bg-white rounded-[20px] border border-[#F0EBF4]">
                  <div className="w-14 h-14 rounded-[18px] bg-[#4B2364]/10 flex items-center justify-center mx-auto mb-3">
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="#4B2364" strokeWidth="1.8" strokeLinecap="round">
                      <circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/>
                    </svg>
                  </div>
                  <p className="text-[14px] font-bold text-[#34094D]">No services found</p>
                  <p className="text-[12px] text-[#7D747F] mt-1">Try switching the filter or category</p>
                </div>
              ) : (
                <div className="grid grid-cols-3 gap-4">
                  {filteredServices.map((s) => {
                    const hasRequested = s.request_status !== null;
                    const isAccessible = s.has_access || s.request_status === "approved";
                    const isRejected   = s.request_status === "rejected";
                    const isPending    = hasRequested && !isAccessible && !isRejected;
                    return (
                      <div
                        key={s.service_id}
                        className="bg-white rounded-[20px] border border-[#F0EBF4] shadow-[0px_4px_16px_rgba(75,35,100,0.06)] p-5 flex flex-col gap-4 hover:shadow-[0px_8px_28px_rgba(75,35,100,0.12)] hover:-translate-y-0.5 transition-all group"
                      >
                        {/* Top row */}
                        <div className="flex items-start justify-between gap-3">
                          <div className="w-12 h-12 rounded-[14px] bg-gradient-to-br from-[#F3EEF8] to-[#EAE0F2] text-[#4B2364] flex items-center justify-center shrink-0 group-hover:from-[#4B2364]/15 group-hover:to-[#754F89]/15 transition-colors">
                            {getIcon(s.slug)}
                          </div>
                          {isAccessible && (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold bg-emerald-50 text-emerald-600 border border-emerald-200 px-2.5 py-1 rounded-full">
                              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 inline-block" />
                              Active
                            </span>
                          )}
                          {isPending && (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold bg-amber-50 text-amber-600 border border-amber-200 px-2.5 py-1 rounded-full">
                              <span className="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block" />
                              Pending
                            </span>
                          )}
                          {isRejected && (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold bg-red-50 text-red-600 border border-red-200 px-2.5 py-1 rounded-full">
                              <span className="w-1.5 h-1.5 rounded-full bg-red-400 inline-block" />
                              Rejected
                            </span>
                          )}
                        </div>

                        {/* Info */}
                        <div className="flex-1">
                          <p className="text-[15px] font-bold text-[#191C1D] mb-1">{s.name}</p>
                          <p className="text-[12px] text-[#7D747F] leading-relaxed line-clamp-2">
                            {s.description || "Available for merchant access request"}
                          </p>
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-between pt-1 border-t border-[#F3F4F5]">
                          <div className="flex items-center gap-1.5">
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#7D747F" strokeWidth="2" strokeLinecap="round">
                              <rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/>
                            </svg>
                            <span className="text-[11px] text-[#7D747F] font-medium">
                              {s.launch_date ? new Date(s.launch_date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "Available now"}
                            </span>
                          </div>
                          <button
                            onClick={() => !isAccessible && (!hasRequested || isRejected) && requestAccess(s.service_id)}
                            disabled={isAccessible || (hasRequested && !isRejected)}
                            className={`px-4 py-1.5 rounded-[10px] text-[12px] font-bold border-none transition-all cursor-pointer ${
                              isAccessible
                                ? "bg-emerald-50 text-emerald-600 cursor-default"
                                : isPending
                                ? "bg-amber-50 text-amber-600 cursor-default"
                                : isRejected
                                ? "bg-gradient-to-r from-[#754F89] to-[#4B2364] text-white hover:opacity-90 shadow-sm"
                                : "bg-gradient-to-r from-[#754F89] to-[#4B2364] text-white hover:opacity-90 hover:shadow-[0px_4px_12px_rgba(75,35,100,0.35)] active:scale-[0.97] shadow-sm"
                            }`}
                          >
                            {isAccessible ? "Accessible" : isPending ? "Requested" : isRejected ? "Re-Request" : "Request Access"}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
            {/* ── Active Service Requests Table ── */}
              <div className="bg-white rounded-[20px] mt-6 shadow-[0px_8px_24px_rgba(75,35,100,0.06)] border border-[#F0EBF4] overflow-hidden">
                <div className="flex items-center justify-between px-6 py-5 border-b border-[#F0EBF4]">
                  <div>
                    <h2 className="text-[24px] font-bold text-[#34094D]">Active Service Requests</h2>
                    <p className="text-[12px] text-[#4C444E] font-medium mt-0.5">Track the status of your submitted service requests.</p>
                  </div>
                  <div className="relative">
                    <svg className="absolute left-3 top-1/2 -translate-y-1/2" width="13" height="13" fill="none" viewBox="0 0 24 24" stroke="#9ca3af" strokeWidth="2">
                      <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35" strokeLinecap="round"/>
                    </svg>
                    <input
                      type="text" value={searchInput} onChange={e => handleSearch(e.target.value)}
                      placeholder="Search service..."
                      className="bg-[#F3F4F5] rounded-[12px] pl-8 pr-4 py-2.5 text-[13px] text-[#191C1D] border-none outline-none focus:ring-2 focus:ring-[#4B2364]/30 w-52 transition"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-3 px-6 py-3 bg-[#F9FAFB] border-b border-[#F0EBF4]">
                  {["Service Name", "Request Status", "Created Date"].map((h, i) => (
                    <p key={h} className={`text-[11px] font-bold text-[#7D747F] uppercase tracking-wider ${i === 2 ? "text-right" : ""}`}>{h}</p>
                  ))}
                </div>

                {activeRequests.length === 0 ? (
                  <div className="py-10 text-center">
                    <p className="text-[13px] text-[#7D747F] font-medium">No results found.</p>
                  </div>
                ) : activeRequests.map((r) => {
                  const statusText = r.status.charAt(0).toUpperCase() + r.status.slice(1);
                  const s = statusStyle[statusText] || statusStyle.Pending;
                  return (
                    <div key={r.service_request_id} className="grid grid-cols-3 px-6 py-4 items-center border-b border-[#F3F4F5] hover:bg-[#FAFAFA] transition-colors last:border-0">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-[10px] bg-[#4B2364]/10 text-[#4B2364] flex items-center justify-center shrink-0">
                          {getIcon(r.service?.slug)}
                        </div>
                        <span className="text-[13px] font-semibold text-[#191C1D]">{r.service?.name}</span>
                      </div>
                      <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold w-fit ${s.cls}`}>
                        <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`}/>{statusText}
                      </span>
                      <p className="text-[12px] text-[#7D747F] font-mono text-right">
                        {r.created_at ? new Date(r.created_at).toISOString().split('T')[0] : 'N/A'}
                      </p>
                    </div>
                  );
                })}

                <div className="flex items-center justify-between px-6 py-4 border-t border-[#F0EBF4]">
                  <p className="text-[12px] text-[#7D747F] font-semibold">
                    {requestPagination.total > 0
                      ? `Showing ${Math.min((page-1)*PAGE_SIZE+1, requestPagination.total)}–${Math.min(page*PAGE_SIZE, requestPagination.total)} of ${requestPagination.total}`
                      : "Showing 0 records"}
                  </p>
                  <div className="flex items-center gap-1.5">
                    <button onClick={() => setPage(p => Math.max(1,p-1))} disabled={page===1}
                      className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#CEC3D0] bg-white text-[#4C444E] hover:bg-gray-50 cursor-pointer disabled:opacity-40 transition-colors">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 18l-6-6 6-6"/></svg>
                    </button>
                    {Array.from({length: Math.min(requestPagination.last_page,5)},(_,i)=>i+1).map(n=>(
                      <button key={n} onClick={()=>setPage(n)}
                        className={`w-8 h-8 flex items-center justify-center rounded-lg text-[12px] font-semibold cursor-pointer transition-colors ${
                          page===n ? "bg-[#34094D] text-white border border-[#34094D]" : "bg-white text-[#4C444E] border border-[#CEC3D0] hover:bg-gray-50"
                        }`}>{n}</button>
                    ))}
                    {requestPagination.last_page>5 && <span className="text-[#7D747F] text-xs px-1">...</span>}
                    <button onClick={()=>setPage(p=>Math.min(requestPagination.last_page,p+1))} disabled={!requestPagination.has_more}
                      className="w-8 h-8 flex items-center justify-center rounded-lg border border-[#CEC3D0] bg-white text-[#4C444E] hover:bg-gray-50 cursor-pointer disabled:opacity-40 transition-colors">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 18l6-6-6-6"/></svg>
                    </button>
                  </div>
                </div>
              </div>
        </div>
  );
}
